import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { database } from "../../lib/cliente";
import { Fornecedores } from "../../types";
import { AtividadesService } from "../atividades/atividades.service";
import { enqueueSnackbar } from "notistack";

const Collection = collection(database, "fornecedores");

export class FornecedoresServiceClass {
  private static _instance: FornecedoresServiceClass;

  static getInstance(): FornecedoresServiceClass {
    if (!this._instance) {
      this._instance = new FornecedoresServiceClass();
    }
    return this._instance;
  }

  async getFornecedor(id: string): Promise<Fornecedores | undefined> {
    const refDoc = doc(Collection, id);
    const res = await getDoc(refDoc);

    return res.data() as Fornecedores;
  }

  async getFornecedores(): Promise<Fornecedores[] | undefined> {
    const fornecedorQuery = query(Collection, orderBy("createdAt", "desc"));
    const users = await getDocs(fornecedorQuery);

    return users.docs.map((item) => ({ ...item.data() })) as Fornecedores[];
  }

  async addFornecedor(data: Fornecedores) {
    try {
      const docRef = await addDoc(Collection, {
        ...data,
        createdAt: serverTimestamp(),
      });

      await updateDoc(docRef, {
        id: docRef.id,
      });

      await AtividadesService.addAtividade(
        `Adicionou um novo fornecedor: ${data.nome}`
      );
      enqueueSnackbar("Fornecedor adicionado com sucesso!", { variant: "success" });
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Algo deu errado! Tente novamente", { variant: "error" });
    }
  }

  async deleteFornecedor(data: Fornecedores) {
    try {
      const docRef = doc(Collection, data.id);

      await deleteDoc(docRef);

      await AtividadesService.addAtividade(
        `Deletou um fornecedor: ${data.nome}`
      );
      enqueueSnackbar("Fornecedor deletado com sucesso!", { variant: "success" });
    } catch (err) {
      console.log("Error:", err);
      enqueueSnackbar("Algo deu errado! Tente novamente", { variant: "error" });
    }
  }

  async updateFornecedor(data: Fornecedores) {
    try {
      const docRef = doc(Collection, data.id);

      await AtividadesService.addAtividade(
        `Atualizou o fornecedor: ${data.nome}`
      );

      await updateDoc(docRef, {
        ...data,
      });
      enqueueSnackbar("Fornecedor atualizado com sucesso!", { variant: "success" });
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Algo deu errado! Tente novamente", { variant: "error" });
    }
  }
}

export const FornecedoresService = FornecedoresServiceClass.getInstance();
